__turbopack_context__.v({
  "CatelogCategorySection": "_8jfoq_CatelogCategorySection",
  "bookCardContainer": "_8jfoq_bookCardContainer",
  "topPaddingCookie": "_8jfoq_topPaddingCookie",
  "topPaddingNoCookie": "_8jfoq_topPaddingNoCookie",
});
